import { Heading, Image, TextLink, TextPassage } from '@petsmart-ui/sparky';

import './feature-card.scss';

export type FeatureCardModel = {
    description?: string;
    href: string;
    imageUrl: string;
    openInNewTab?: boolean;
    title: string;
};

type FeatureCardProps = {
    card: FeatureCardModel;
    onClick?: () => void;
};

export function FeatureCard({ card, onClick }: FeatureCardProps) {
    return (
        <TextLink
            href={card.href}
            className="feature-card"
            onClick={onClick}
            rel={card.openInNewTab ? 'noopener noreferrer' : undefined}
            target={card.openInNewTab ? '_blank' : undefined}
        >
            <Image className="feature-card__image" src={card.imageUrl} alt="" />
            <Heading className="feature-card__title" tagName="h3" size="body-bold">
                {card.title}
            </Heading>
            {card.description && (
                <TextPassage className="feature-card__description" size="sm">
                    {card.description}
                </TextPassage>
            )}
        </TextLink>
    );
}
